module.exports = "/_next/static/images/Hero@2x-bba0e850862324d2ee38c2650641dd50.webp";